import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowRight, Key } from "@phosphor-icons/react";
import api, { formatErr } from "@/lib/api";
import ThemeToggle from "@/components/layout/ThemeToggle";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password !== confirm) {
      setErr("Passwords do not match");
      return;
    }
    if (!token) {
      setErr("Invalid reset link");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login", { replace: true, state: { message: "Password updated. Sign in with your new password." } });
    } catch (e) {
      setErr(formatErr(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-app-bg text-app-text p-4 relative">
      <div className="absolute top-3 right-3"><ThemeToggle compact /></div>
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="reset-form">
        <div className="font-mono-d text-[10px] uppercase tracking-[0.3em] text-app-subtle mb-2">New credentials</div>
        <h1 className="font-display font-black text-2xl tracking-tight mb-6">Set new password</h1>

        <div className="mb-4">
          <label className="block font-mono-d text-[10px] uppercase tracking-widest text-app-subtle mb-2">New password</label>
          <input
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-app-surface border border-app-border px-3 py-3 text-sm focus:outline-none focus:border-[#007AFF] min-h-[44px]"
          />
        </div>
        <div className="mb-6">
          <label className="block font-mono-d text-[10px] uppercase tracking-widest text-app-subtle mb-2">Confirm password</label>
          <input
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="w-full bg-app-surface border border-app-border px-3 py-3 text-sm focus:outline-none focus:border-[#007AFF] min-h-[44px]"
          />
        </div>

        {err && <div className="mb-4 px-3 py-2 bg-[#FF3B30]/10 border border-[#FF3B30]/30 text-[#FF6B61] text-xs">{err}</div>}

        <button
          type="submit"
          disabled={loading || !token}
          className="btn-touch w-full bg-[#007AFF] hover:bg-[#3395FF] disabled:opacity-50 text-white py-3 text-sm font-semibold flex items-center justify-center gap-2"
        >
          <Key size={14} />
          {loading ? "Updating…" : "Update password"}
          <ArrowRight size={14} weight="bold" />
        </button>

        <Link to="/login" className="block mt-4 text-center font-mono-d text-[10px] uppercase tracking-widest text-app-subtle hover:text-app-text">
          Back to sign in
        </Link>
      </form>
    </div>
  );
}
